// @flow
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import Datepicker from 'antd/lib/date-picker';

import {formatDateTimeToISOString} from './../../../lib/helpers';

import {Filter, FilterButtonsContainer, FilterContainer, FilterItem} from './../../../components';
import OrgUnitSelect from './../../../components/OrgUnitSelect';
import type {FilterChildrenParams} from './../../../components/hoc/Filter';
import Field from './../../../components/card/Field';

const { RangePicker } = Datepicker;

const SpoilerContent = styled.div`
  padding: 16px;
`;

export type MaintenanceOperationPriceFilterParams = {
  orgUnitId?: number,
  operationId?: number,
  startDate?: string,
  endDate?: string
};

type Props = {
  filter: MaintenanceOperationPriceFilterParams,
  cleanFilter: Function,
  applyFilter: Function
};

export const MaintenanceOperationPriceFilter = ({
  filter,
  cleanFilter,
  applyFilter
}: Props) => (
  <SpoilerContent>
    <FilterContainer>
      <Filter
        cleanFilter={cleanFilter}
        applyFilter={applyFilter}
        initialValues={filter}
      >
        {({
          values,
          changeValue,
          applyFilter,
          cleanFilter
        }: FilterChildrenParams<MaintenanceOperationPriceFilterParams>) => (
          <>
            <FilterItem>
              <Field mBottomNone>
                <OrgUnitSelect
                  placeholder="Выберите филиал"
                  onlyBranches
                  size="small"
                  onChange={value => changeValue('orgUnitId', value)}
                  value={values.orgUnitId}
                  isFilter={true}
                />
              </Field>
            </FilterItem>

            <FilterItem>
              <RangePicker
                format="DD.MM.YYYY"
                size="small"
                placeholder={['Начало', 'Конец']}
                value={[
                  values.startDate ? moment.utc(values.startDate) : null,
                  values.endDate ? moment.utc(values.endDate) : null
                ]}
                onChange={(value, dateString) => {
                  const [startDate, endDate] = value;
                  const [startDateString, endDateString] = dateString;
                  changeValue(
                    'startDate',
                    formatDateTimeToISOString(startDate, startDateString)
                  );
                  changeValue(
                    'endDate',
                    formatDateTimeToISOString(endDate, endDateString)
                  );
                }}
              />
            </FilterItem>

            <FilterButtonsContainer
              applyFilter={applyFilter}
              cleanFilter={cleanFilter}
            />
          </>
        )}
      </Filter>
    </FilterContainer>
  </SpoilerContent>
);

export default MaintenanceOperationPriceFilter;
